import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Ordine} from '../../_models/Ordine';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {LocalService} from '../../_services/local.service';
import {SaveMessage} from '../../_helpers/save-message';
import {GroupResult} from '../../_models/GroupResult';
import {SearchResult} from '../../_models/SearchResult';
import {OrdineGroup} from '../../_models/OrdineGroup';
import {Subscription} from 'rxjs';
import {HubMonitorService} from '../../_services/hub-monitor.service';

@Component({
    selector: 'app-ordini-locali-groupbymany',
    templateUrl: './ordini-locali-groupbymany.component.html',
    styleUrls: ['./ordini-locali-groupbymany.component.scss'],
    standalone: false
})
export class OrdiniLocaliGroupbymanyComponent  implements OnInit, OnChanges, OnDestroy {
  @Input() flagTerminate: boolean;
  @Input() groupingContext = '';
  @Output() ordineGroupSended = new EventEmitter<OrdineGroup>();
  sortDirection = true;
  sortKey = 'dataTermine';
  ordiniGroups: GroupResult<Ordine>[] = [];
  page = 0;
  count = 20;
  loadMore = false;
  loading = false;
  hasLoaded = false;
  selectedOrdiniGroup: OrdineGroup;
  subscription: Subscription;
  private requestToken = 0;

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private localService: LocalService,
    private saveMessage: SaveMessage,
    private hubMonitorService: HubMonitorService) { }

  ngOnInit() {
    this.selectedOrdiniGroup = this.localService.getEmptyOrder();
    this.selectedOrdiniGroup.ordini = [];
    //this.getOrdiniGroupByMany(false);
    this.subscription = this.localService.searchText.subscribe((_value: string) => {
      this.getOrdiniGroupByMany(false);
    });
    this.subscription.add(this.localService.handleRefresh.subscribe(() => this.getOrdiniGroupByMany(false)));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.groupingContext && !changes.groupingContext.firstChange && this.subscription) {
      this.selectedOrdiniGroup.ordini = [];
      void this.getOrdiniGroupByMany(false);
    }
  }

  getOrdiniGroupByMany = async (add: boolean): Promise<void> => {
    if (add && this.loading) {
      return;
    }
    const token = ++this.requestToken;
    const groupColumns = this.organizzazioniService.groupColumnsArray;
    this.hasLoaded = false;
    if (groupColumns.length === 0) {
      this.ordiniGroups = [];
      this.page = 0;
      this.loadMore = false;
      this.loading = false;
      if (this.selectedOrdiniGroup) {
        this.selectedOrdiniGroup.ordini = [];
      }
      return;
    }
    this.loadMore = true;
    this.loading = true;
    if (!add) {
      this.ordiniGroups = [];
      this.page = 0;
    } else {
      this.page += 1;
    }
    const search = this.localService.searchText.getValue().toString();
    try {
      const _result: SearchResult<GroupResult<Ordine>> = await this.localService.getOrdiniInviatiFilteredGroupByMany(this.organizzazioniService.organizzazioneId,
        this.flagTerminate, search, this.page, this.count, this.sortKey, this.sortDirection,
        this.localService.localFilters.value, groupColumns);
      if (token !== this.requestToken) {
        return;
      }
      if (_result.hasErrors) {
        throw new Error('Il raggruppamento non è disponibile.');
      }
      this.hasLoaded = true;
      if (_result.totalCount === 0) {
        this.ordiniGroups = [];
        this.loadMore = false;
        return;
      }
      if (!add) {
        this.ordiniGroups = _result.result;
      } else {
        _result.result.forEach((ord: GroupResult<Ordine>) => this.ordiniGroups.push(ord));
      }
      this.loadMore = _result.totalCount > this.ordiniGroups.length;
    } catch {
      if (token === this.requestToken) {
        this.saveMessage.messageError("Ci sono problemi con il raggruppamento gerarchico.");
      }
    } finally {
      if (token === this.requestToken) {
        this.loading = false;
      }
    }
  };

  addOrdini = (ordini: Ordine[]) => ordini.forEach((_ordine: Ordine) => {
    if (this.selectedOrdiniGroup.ordini.indexOf(_ordine) < 0) {
      this.selectedOrdiniGroup.ordini.push(_ordine);
    }
  });

  confirmOrdineGroup = () => this.ordineGroupSended.emit(this.selectedOrdiniGroup);

  openHubMonitor(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.hubMonitorService.requestOpenHubMonitor();
  }

  ngOnDestroy() {
    this.requestToken += 1;
    this.subscription.unsubscribe();
  }
}
